import FaqBanner from './FaqBanner'

export default FaqBanner
